import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Auth/AuthService';

@Component({
  selector: 'app-payment-rejected',
  imports: [],
  templateUrl: './payment-rejected.component.html',
 styleUrls: ['../../../../auth.scss'],
})
export class PaymentRejectedComponent {

  constructor(private router: Router, private authService: AuthService) { }
  @ViewChild('confetti') confettiContainer!: ElementRef;

  goToHomepage() {
    this.router.navigate(['/']);
  }

  goToBilling() {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/home/subscription']);
    } else {
      this.router.navigate(['/auth/pricing']);
    }
  }
}
